import { State } from './definition.state';
import { globalMapObject } from '../module';
import ol from 'openlayers';
import { providerProduct, Product } from '../providers/provider.product';
import * as http from 'gs-browser-http';
import { providerSubmit } from '../providers/provider.submit';
import { cfg } from '../config';

declare type InputParameterTypeLocal = { name: string, area: number, coordinates: number[][], products: string[] };
declare type PassOverParameterTypeLocal = undefined;


// const product_name_label_map: { [name: string]: string } = {
//     "Topography": "We recommend using our highest resolution topography product (based on LiDAR at 2x2m resolution) but where this does not provide complete coverage (see below and map for coverage) for your area you may wish to select a lower resolution product." 
//     + "<br><div style='margin-top:5px;'><u>Please select:</u></div>"
// }

export class StateSelectDataset extends State<InputParameterTypeLocal, PassOverParameterTypeLocal> {

    private _products: Product[] = [];
    private raster: any;
    private _product_title: HTMLDivElement[] = [];
    private _product_dataset_label_div: HTMLDivElement[][] = [];
    private _product_dataset_coverage_value: number[][] = [];
    private _product_dataset_verify_text_div: HTMLDivElement = document.createElement("div");
    private _product_dataset_info_curtain: HTMLDivElement = document.createElement("div");

    private _product_selected_dataset: { theme: string, id: string }[] = [];

    // override
    constructor(node_application_container: HTMLDivElement) {
        super(node_application_container);
        this.id = 'select-dataset';

        this.init(node_application_container);
    }

    // override
    get passOverPrameters() {
        this._passOverPrameters = undefined;
        return super.passOverPrameters;
    }

    // post activate function. It is used (via override) to do something after activate (eg change mode when no default mode is needed)
    // notice that on activate default mode is used
    // override
    protected onActivated() {
        // console.log('onActivated override');
        let p = this.getFirstProductWithDataset();
        if (p) {
            this.setMode(<any>p.id);
            let u = this.getUrl(p, 0);
            // console.log(u);
            if (u !== undefined) { this.add_coverage_image(this._products.findIndex(v => v.id === p.id), u.url, u.coordinates); }
            // console.log(this._product_dataset_label_div)
            this._products.forEach((p, index) => {
                if (p.dataset && p.dataset.length > 0) {
                    p.dataset.forEach((d, i) => {
                        let u = this.getUrl(p, i);
                        console.log(p);
                        console.log(u);
                        if (u !== undefined)
                            http.GET(u.url, { headers: { "accept": "application/json" } }).then(d2 => {
                                let ob: { value: number, size: [number, number] } = JSON.parse(d2.data);
                                console.log(ob);
                                this._product_dataset_coverage_value[index][i] = ob.value;
                                this._product_dataset_label_div[index][i].innerHTML = d.name + ` (${Math.round(ob.value * 1000) / 10}% coverage)`;
                            });
                    })
                }
            });

        }
    }

    // post activate function. It is used (via override) to do something after activate (eg change mode when no default mode is needed)
    // notice that on activate default mode is used
    // override
    protected onDisactivated() {
        if (this.raster) {
            globalMapObject.map.removeLayer(this.raster);
            this.raster = undefined;
        }
    }



    private async init(parent_container: HTMLDivElement) {



        this._product_dataset_info_curtain = document.createElement("div");
        this._product_dataset_info_curtain.className = 'info-curtain';
        parent_container.appendChild(this._product_dataset_info_curtain);
        this._product_dataset_info_curtain.style.display = 'none';

        {
            this._product_dataset_verify_text_div = document.createElement("div");
            this._product_dataset_verify_text_div.className = 'proceed-text';
            this._product_dataset_verify_text_div.innerHTML = ``;
            this._product_dataset_info_curtain.appendChild(this._product_dataset_verify_text_div);
        }



        this._products = await providerProduct.get();

        let modes: string[] = [];
        this._product_selected_dataset = this._products.map((p, index) => ({ theme: (p.dataset) ? p.dataset[0].theme : '', id: (p.dataset) ? p.dataset[0].id : '' }));

        this._products.forEach((p, index) => {
            this._product_dataset_label_div[index] = [];
            this._product_dataset_coverage_value[index] = [];
            if (p.dataset && p.dataset.length > 0) {
                this.addMode(<any>p.id).attachAction(() => {
                    // console.log(this._inputPrameters);
                });

                modes.push(p.id);

                let stateItem = this.createDomItem(parent_container, 'client-dataset-selector-' + p.id, { className: 'dataset-widget', modeDomLink: [<any>p.id], stateItem: true });
                stateItem.style.fontSize = '10pt';
                stateItem.style.maxWidth = '60%';
                stateItem.style.textAlign = 'justify';
                this._product_title[index] = this.createDomItem(stateItem, 'client-dataset-selector-title', {});
                this._product_title[index].innerHTML = p.label || p.name; //product_name_label_map[p.name] || p.name;

                p.dataset.forEach((d, i) => {
                    let o = this.createDomItem(stateItem, '', { className: 'dataset-selector-item' });
                    let s: HTMLInputElement = document.createElement("input");
                    s.type = "radio";
                    s.name = p.id;
                    s.checked = i === 0;
                    s.addEventListener('change', () => {
                        let u = this.getUrl(p, i);
                        if (u !== undefined) { this.add_coverage_image(index, u.url, u.coordinates); }
                        this._product_selected_dataset[index] = { theme: d.theme, id: d.id };
                    });
                    o.appendChild(s);
                    let o2 = this.createDomItem(o, '', {});
                    o2.innerHTML = d.name;
                    this._product_dataset_label_div[index].push(o2);
                })
            }
        });
        // this.setMode(<any>this.getFirstProductWithDataset().id);

        let stateItem = this.createDomItem(parent_container, 'dataset-navigate', { className: 'global-selector-navigate-container global-selector-navigate-container-bg', modeDomLink: <any>modes, stateItem: true });
        let p = this.createDomItem(stateItem, 'dataset-previous', { className: 'global-selector-navigate', stateChange: { sourceStateId: this.id, targetStateId: 'select-product' } }); p.innerHTML = ' < back';
        let n = this.createDomItem(stateItem, 'dataset-next', { className: 'global-selector-navigate' }); n.innerHTML = 'next > ';
        n.addEventListener('click', () => {
            // let area = (this._inputPrameters !== undefined) ? this._inputPrameters.area : 0;
            // let geom = (this._inputPrameters !== undefined) ? this._inputPrameters.coordinates : [];
            // // console.log(area);
            // // console.log(geom.map(c => ol.proj.transform(<any>c, 'EPSG:3857', 'EPSG:4326')))
            // let productsId = (this._inputPrameters !== undefined) ? this._inputPrameters.products : [];
            // console.log(this._inputPrameters);
            // console.log(this._product_selected_dataset);
            // console.log('here have to send data');
            let has_message = this.set_verify_dataset_text();
            if(has_message === true){
                this._product_dataset_info_curtain.style.display = 'block';
            }else{
                this.submit();
            }
            // providerSubmit.submit(area, geom.map(c => ol.proj.transform(<any>c, 'EPSG:3857', 'EPSG:4326')), productsId, this._product_selected_dataset, (this._inputPrameters !== undefined) ? this._inputPrameters.name : "");
        });

        this.setMode('default');
    }



    private set_verify_dataset_text() : boolean{
        // this._product_dataset_verify_text_div
        let out: boolean = false;
        let dataset_list = this._product_selected_dataset.filter(d => d.id !== "" && d.theme !== "");
        if (dataset_list.length > 0) {
            this._products.forEach((application_product_item, product_index) => {
                if (application_product_item.dataset != undefined) {
                    application_product_item.dataset.forEach((product_ddataset, dataset_index) => {
                        if (product_ddataset.verifyText !== undefined && dataset_list.some(dataset => dataset.id === product_ddataset.id && dataset.theme === product_ddataset.theme)) {
                            let coverage = this._product_dataset_coverage_value[product_index][dataset_index];
                            let coverage_text = "<b>" + (Math.round(coverage * 1000) / 10).toFixed(1) + "%</b>";
                            this._product_dataset_verify_text_div.innerHTML = product_ddataset.verifyText.replace(/\{\{coverage\}\}/g, coverage_text);

                            
                            let proceed = document.createElement("div");
                            proceed.className = 'verify-proceed-button';
                            proceed.innerHTML = `Proceed`;
                            this._product_dataset_verify_text_div.appendChild(proceed);

                            proceed.addEventListener('click', () => {
                                this._product_dataset_info_curtain.style.display = 'none';
                                this.submit();
                            });


                            let cancel = document.createElement("div");
                            cancel.className = 'verify-cancel-button';
                            cancel.innerHTML = `Cancel`;
                            this._product_dataset_verify_text_div.appendChild(cancel);

                            cancel.addEventListener('click', () => {
                                this._product_dataset_info_curtain.style.display = 'none';
                            });



                            out = true;
                        }
                    })
                }
            });
        }

        return out;
    }


    private submit() {
        let area = (this._inputPrameters !== undefined) ? this._inputPrameters.area : 0;
        let geom = (this._inputPrameters !== undefined) ? this._inputPrameters.coordinates : [];
        let productsId = (this._inputPrameters !== undefined) ? this._inputPrameters.products : [];
        console.log(this._inputPrameters);
        console.log(this._product_selected_dataset);
        console.log('here have to send data');
        providerSubmit.submit(area, geom.map(c => ol.proj.transform(<any>c, 'EPSG:3857', 'EPSG:4326')), productsId, this._product_selected_dataset, (this._inputPrameters !== undefined) ? this._inputPrameters.name : "");
    }


    private getUrl(ofProduct: Product, atIndex: number) {
        if (this._inputPrameters && ofProduct && ofProduct.dataset) {
            let d = ofProduct.dataset[atIndex];
            let url = cfg.apiUrlBase + '/api/rest/v1/theme/'
                + d.theme
                + '/dataset/'
                + d.id
                + '/coverage/search/{"operator":"for","value":{"geom":{"type":"Polygon",'
                + '"coordinates":[['
                + this._inputPrameters.coordinates
                    .map(c => ol.proj.transform([c[0], c[1]], 'EPSG:3857', 'EPSG:4326'))
                    .map(c => '[' + c[0] + ',' + c[1] + ']')
                    .join(',')
                + ']]}}}';
            // console.log('should take extent');
            return { url: url, coordinates: <any>this._inputPrameters.coordinates };
        }
        return undefined;
    }


    private getFirstProductWithDataset() {
        return this._products.filter(p => p.dataset !== undefined && p.dataset.length > 0)[0];
    }

    private add_coverage_image(product_index: number, img_url: string, coordinates: [number, number][]) {
        http.GET(img_url, { headers: { "accept": "application/json" } }).then(d => {
            let ob: { value: number, size: [number, number] } = JSON.parse(d.data);
            // let name = product_name_label_map[this._products[product_index].name] || this._products[product_index].name;
            // this._product_title[product_index].innerHTML = name + ` (coverage: ${Math.round(ob.value * 1000) / 10}%)`;
            let xcoor = coordinates.map(c => c[0]);
            let ycoor = coordinates.map(c => c[1]);
            const p1: [number, number] = [Math.min(...xcoor), Math.min(...ycoor)]//coordinates[0]; //ol.proj.transform([this.center_10km[0] - 5000, this.center_10km[1] - 5000], 'EPSG:27700', 'EPSG:3857');
            // const p2: [number, number] = coordinates[1]; //ol.proj.transform([this.center_10km[0] - 5000, this.center_10km[1] + 5000], 'EPSG:27700', 'EPSG:3857');
            const p3: [number, number] = [Math.max(...xcoor), Math.max(...ycoor)]//coordinates[2]; //ol.proj.transform([this.center_10km[0] + 5000, this.center_10km[1] + 5000], 'EPSG:27700', 'EPSG:3857');
            // const p4: [number, number] = coordinates[3]; //ol.proj.transform([this.center_10km[0] + 5000, this.center_10km[1] - 5000], 'EPSG:27700', 'EPSG:3857');
            if (this.raster) {
                globalMapObject.map.removeLayer(this.raster);
            }
            const s = new ol.source.ImageStatic({
                url: img_url,
                imageSize: ob.size,
                imageExtent: [p1[0], p1[1], p3[0], p3[1]],
                projection: 'EPSG:3857'
            });
            this.raster = new ol.layer.Image({
                source: s
            });
            globalMapObject.map.addLayer(this.raster);
        });
    }
}
